import { reactive } from 'vue';
const ageRatings = [{
        id: null,
        name: null,
    }];
const contractors = [{
        id: null,
        name: null,
        trade_name: null,
    }];
const bindingMethods = [{
        id: null,
        name: null,
    }];
const bindingSides = [{
        id: null,
        name: null,
    }];
const subdivisions = [{
        id: null,
        name: null,
        trend: null,
    }];
const promoters = [{
        id: null,
        name: null,
        kana: null,
        note: null,
    }];
const venues = [{
        id: null,
        name: null,
    }];
const events = [{
        id: null,
        name: null,
        event_at: null,
        trend: null,
        subdivisions: subdivisions,
        promoters: promoters,
        venues: venues,
    }];
const forwardings = [{
        id: null,
        forwarding_id: null,
        arrive_at: null,
        lot: null,
        options: null,
    }];
const memberProfiles = [{
        id: null,
        first_name: null,
        last_name: null,
        first_name_kana: null,
        last_name_kana: null,
        postcode: { id: null, name: null, code: null },
        prefecture: { id: null, name: null },
        address1: null,
        address2: null,
        building: null,
        tel: null,
        birth_at: null,
        circle: null,
        pen_name: null,
    }];
const members = [{
        id: null,
        email: null,
        profiles: memberProfiles,
    }];
const manuScripts = [{
        id: null,
        hash: null,
        ext: null,
        note: null,
        title: null,
        age_ratings: ageRatings,
    }];
const operatingSystems = [{
        id: null,
        name: null,
    }];
const paperPurposes = [];
for (let i = 0; i < 3; i++) {
    const colorModels = [{
            id: null,
            name: null,
        }];
    const drawingTools = [{
            id: null,
            name: null,
        }];
    const paperCoatings = [{
            id: null,
            name: null,
            price: 0,
        }];
    const paperPositions = [{
            id: null,
            name: null,
            price: 0,
        }];
    const paperTypes = [{
            id: null,
            name: null,
        }];
    const productions = [{
            id: null,
            order_plan_paper_purpose_id: null,
            drawing_tools: drawingTools,
            color_models: colorModels,
        }];
    const tints = [{
            id: null,
            name: null,
        }];
    paperPurposes.push({
        id: null,
        name: null,
        paper_coatings: paperCoatings,
        paper_positions: paperPositions,
        paper_types: paperTypes,
        productions: productions,
        tints: tints,
    });
}
const paperSizes = [{
        id: null,
        name: null,
    }];
const payments = [{
        id: null,
        pay_method: null,
        price: 0,
        option: 0,
        shipping: 0,
        total: 0,
    }];
const printingMethods = [{
        id: null,
        name: null,
    }];
export const forms = reactive([{
        id: null,
        mode: null,
        path_name: null,
        type: null,
        manuscripts: manuScripts,
        members: members,
        plans: [{
                mode: null,
                id: null,
                binding_methods: bindingMethods,
                binding_sides: bindingSides,
                contractors: contractors,
                events: events,
                forwardings: forwardings,
                operating_systems: operatingSystems,
                paper_purposes: paperPurposes,
                paper_sizes: paperSizes,
                printing_methods: printingMethods,
                arrive_at: null,
                pages: [{ value: 0 }],
                lots: [{ value: 0 }],
            }],
        payments: payments,
        cover_coating_error: null
    }]);
